<template>
  <transition name="fade">
    <div class="signup__bar" v-if="barVisible">
      <div class="container">
        <div class="row">
          <div class="col-24">
            <div class="bar__inner">
              <div>
                <strong>Are You A Water-Right Contractor?&nbsp;</strong>Sign up
                for contractor tools and resources.
              </div>
              <a href="/for-contractors/#contractor__signup" class="btn"
                >Sign Up Now</a
              >
              <div class="bar__close" @click.prevent="barVisible = false"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "AppStickyContractor",

  data() {
    return {
      barVisible: true,
    };
  },
};
</script>
